module.exports = __webpack_public_path__ + "fonts/AvenirNextCondensed-BoldItalic.654807f3.woff2";